var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x92\xD0\xB5\xD1\x80\xD0\xB8\xD1\x84\xD0\xB8\xD1\x86\xD0\xB8\xD1\x80\xD0\xBE\xD0\xB2\xD0\xB0\xD0\xBD\xD0\xBD\xD1\x8B\xD0\xB9 \xD0\xB0\xD0\xBA\xD0\xBA\xD0\xB0\xD1\x83\xD0\xBD\xD1\x82 \xD0\xBF\xD0\xBE\xD0\xBB\xD1\x8C\xD0\xB7\xD0\xBE\xD0\xB2\xD0\xB0\xD1\x82\xD0\xB5\xD0\xBB\xD1\x8F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1098 -1100C-1098 -1101.1 -1097.1 -1102 -1096 -1102H8839C8840.1 -1102 8841 -1101.1 8841 -1100V2003C8841 2004.1 8840.1 2005 8839 2005H-1096C-1097.1 2005 -1098 2004.1 -1098 2003V-1100Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1096 -1101H8839V-1103H-1096V-1101ZM8840 -1100V2003H8842V-1100H8840ZM8839 2004H-1096V2006H8839V2004ZM-1097 2003V-1100H-1099V2003H-1097ZM-1096 2004C-1096.55 2004 -1097 2003.55 -1097 2003H-1099C-1099 2004.66 -1097.66 2006 -1096 2006V2004ZM8840 2003C8840 2003.55 8839.55 2004 8839 2004V2006C8840.66 2006 8842 2004.66 8842 2003H8840ZM8839 -1101C8839.55 -1101 8840 -1100.55 8840 -1100H8842C8842 -1101.66 8840.66 -1103 8839 -1103V-1101ZM-1096 -1103C-1097.66 -1103 -1099 -1101.66 -1099 -1100H-1097C-1097 -1100.55 -1096.55 -1101 -1096 -1101V-1103Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9F\xD1\x80\xD0\xB8 \xD0\xBD\xD0\xB0\xD0\xB2\xD0\xBE\xD0\xB4\xD0\xBA\xD0\xB5",
    clipPath: "url(#clip0_759_1216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2107,
    transform: "translate(-598 -602)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9F\xD1\x80\xD0\xBE\xD1\x84\xD0\xB8\xD0\xBB\xD1\x8C \xD0\xBF\xD0\xBE\xD0\xBB\xD1\x8C\xD0\xB7\xD0\xBE\xD0\xB2\xD0\xB0\xD1\x82\xD0\xB5\xD0\xBB\xD1\x8F",
    filter: "url(#filter0_d_759_1216)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -468,
    y: -366,
    width: 1660,
    height: 712,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9E\xD0\xBF\xD0\xB8\xD1\x81\xD0\xB0\xD0\xBD\xD0\xB8\xD0\xB5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x90\xD0\xB2\xD0\xB0\xD1\x82\xD0\xB0\xD1\x80\xD0\xBA\xD0\xB0 \xD0\xB8 \xD0\xB4\xD0\xB0\xD0\xBD\xD0\xBD\xD1\x8B\xD0\xB5 \xD0\xBF\xD0\xBE\xD0\xBB\xD1\x8C\xD0\xB7\xD0\xBE\xD0\xB2\xD0\xB0\xD1\x82\xD0\xB5\xD0\xBB\xD1\x8F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.77578 12.9306C5.55684 11.9444 5.59046 10.9189 5.87351 9.94914C6.15657 8.97939 6.6799 8.0968 7.39498 7.38322C8.11006 6.66963 8.99374 6.14815 9.96409 5.86713C10.9344 5.5861 11.96 5.55463 12.9458 5.77563C13.4883 4.92709 14.2358 4.22877 15.1192 3.74506C16.0026 3.26135 16.9936 3.00781 18.0008 3.00781C19.008 3.00781 19.9989 3.26135 20.8824 3.74506C21.7658 4.22877 22.5132 4.92709 23.0558 5.77563C24.043 5.55367 25.0704 5.585 26.0423 5.8667C27.0142 6.14841 27.899 6.67135 28.6145 7.38686C29.3301 8.10238 29.853 8.98724 30.1347 9.95914C30.4164 10.931 30.4477 11.9584 30.2258 12.9456C31.0743 13.4882 31.7726 14.2356 32.2563 15.1191C32.7401 16.0025 32.9936 16.9935 32.9936 18.0006C32.9936 19.0078 32.7401 19.9988 32.2563 20.8822C31.7726 21.7656 31.0743 22.5131 30.2258 23.0556C30.4468 24.0414 30.4153 25.067 30.1343 26.0373C29.8533 27.0077 29.3318 27.8913 28.6182 28.6064C27.9046 29.3215 27.022 29.8448 26.0523 30.1279C25.0825 30.411 24.057 30.4446 23.0708 30.2256C22.5289 31.0774 21.7809 31.7787 20.896 32.2646C20.011 32.7505 19.0178 33.0052 18.0083 33.0052C16.9987 33.0052 16.0055 32.7505 15.1206 32.2646C14.2357 31.7787 13.4876 31.0774 12.9458 30.2256C11.96 30.4466 10.9344 30.4152 9.96409 30.1341C8.99374 29.8531 8.11006 29.3316 7.39498 28.6181C6.6799 27.9045 6.15657 27.0219 5.87351 26.0521C5.59046 25.0824 5.55684 24.0568 5.77578 23.0706C4.92071 22.5295 4.2164 21.7809 3.72835 20.8945C3.2403 20.008 2.98437 19.0125 2.98438 18.0006C2.98437 16.9887 3.2403 15.9932 3.72835 15.1068C4.2164 14.2204 4.92071 13.4718 5.77578 12.9306Z",
    fill: "#91172C",
    stroke: "#91172C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5 18L16.5 21L22.5 15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Component 17",
    clipPath: "url(#clip1_759_1216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.77578 12.9306C5.55684 11.9444 5.59046 10.9189 5.87351 9.94914C6.15657 8.97939 6.6799 8.0968 7.39498 7.38322C8.11006 6.66963 8.99374 6.14815 9.96409 5.86713C10.9344 5.5861 11.96 5.55463 12.9458 5.77563C13.4883 4.92709 14.2358 4.22877 15.1192 3.74506C16.0026 3.26135 16.9936 3.00781 18.0008 3.00781C19.008 3.00781 19.9989 3.26135 20.8824 3.74506C21.7658 4.22877 22.5132 4.92709 23.0558 5.77563C24.043 5.55367 25.0704 5.585 26.0423 5.8667C27.0142 6.14841 27.899 6.67135 28.6145 7.38686C29.3301 8.10238 29.853 8.98724 30.1347 9.95914C30.4164 10.931 30.4477 11.9584 30.2258 12.9456C31.0743 13.4882 31.7726 14.2356 32.2563 15.1191C32.7401 16.0025 32.9936 16.9935 32.9936 18.0006C32.9936 19.0078 32.7401 19.9988 32.2563 20.8822C31.7726 21.7656 31.0743 22.5131 30.2258 23.0556C30.4468 24.0414 30.4153 25.067 30.1343 26.0373C29.8533 27.0077 29.3318 27.8913 28.6182 28.6064C27.9046 29.3215 27.022 29.8448 26.0523 30.1279C25.0825 30.411 24.057 30.4446 23.0708 30.2256C22.5289 31.0774 21.7809 31.7787 20.896 32.2646C20.011 32.7505 19.0178 33.0052 18.0083 33.0052C16.9987 33.0052 16.0055 32.7505 15.1206 32.2646C14.2357 31.7787 13.4876 31.0774 12.9458 30.2256C11.96 30.4466 10.9344 30.4152 9.96409 30.1341C8.99374 29.8531 8.11006 29.3316 7.39498 28.6181C6.6799 27.9045 6.15657 27.0219 5.87351 26.0521C5.59046 25.0824 5.55684 24.0568 5.77578 23.0706C4.92071 22.5295 4.2164 21.7809 3.72835 20.8945C3.2403 20.008 2.98437 19.0125 2.98438 18.0006C2.98437 16.9887 3.2403 15.9932 3.72835 15.1068C4.2164 14.2204 4.92071 13.4718 5.77578 12.9306Z",
    fill: "#91172C",
    stroke: "#91172C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.5 18L16.5 21L22.5 15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_759_1216",
    x: -472,
    y: -370,
    width: 1668,
    height: 720,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_759_1216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_759_1216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_1216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2107,
    fill: "white",
    transform: "translate(-598 -602)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_759_1216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 477,
    height: 98,
    fill: "white",
    transform: "translate(0 -62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.928889b77c0f7c82c7434946e34903c7.svg";
export { ForwardRef as ReactComponent };